import { Link } from "react-router-dom"
import React, { useState } from "react"
import landingBanner from "../../assets/landing-page-image.png"

export default function PcLandingPage() {
  const [store, setStore] = useState("Kirana");
  const storeArr = ["Kirana", "Vegetable", "Fruit", "Dairy"];

  // setTimeout(function(){
    
  // }, 3000);

  return (
    <div className="pc-landing-page mw-14">
      <div className="intro-content">
        <div className="patna">🌆From Patna for Patna🥬</div>
        <h1 className="g-h1">
          Shop from <br /> Your Nearby
        </h1>
        <h1 className="b-h1">{store} Shop</h1>
        <code>
          Patna's most convenient online grocery channel SabjiGrocery makes your
          grocery shopping even simpler and at affordable prices right at your
          doorstep.
        </code>
        <div className="landing-btns d-flex">
          <button className="call-us">
            <ion-icon name="call"></ion-icon>75449 90999
          </button>
          <Link to="/shop-on-whatsapp">
            <button className="shop-on-wa">
              <ion-icon name="logo-whatsapp"></ion-icon>
              <h3>Shop on whatsapp</h3>
            </button>
          </Link>
        </div>
      </div>
      <div className="intro-ima">
        <img src={landingBanner} alt="landing banner" />
      </div>
    </div>
  )
}
